import Logger from '../lib/logger';
import CustomBundle from './CustomBundle';
import ConfiguratorSideCart from './ConfiguratorSideCart'
import NumberButton from './NumberButton';
import ConfiguratorModal from './ConfiguratorModal';
import ImageUpload from './ImageUpload';
import IndexDBService from '../lib/indexDB.service';
import ConfiguratorFilters from './ConfiguratorFilters';

export default function() {
  const NAME = 'ConfigureBundleStep1';
  const customBundle = new CustomBundle();
  const sideCart = new ConfiguratorSideCart(1);
  const backBtns = document.querySelectorAll('[data-back-btn]');
  const intersectional = document.querySelector('configurator-intersectional-observer');
  const filters = document.querySelector('configurator-filters');
  const confirmModal = document.querySelector('configurator-modal[content-type="confirm"]');
  let selectBtns = Array.from(document.querySelectorAll('[data-select-product-btn]'));
  const productModal = document.querySelector('configurator-modal[content-type="product"]');
  let productModalLaunchBtns = Array.from(document.querySelectorAll('[data-launch-modal]'));
  let items = document.querySelectorAll('.configurator-grid__items__grid-item');
  const startNew = !window.location.search.includes('edit=');
  let curSelectBtn;
  let bundleData = customBundle.data;
  const indexDBService = new IndexDBService();
  
  const init = async () => {
    Logger.info(`${NAME} > init`);
    // redirect if not custom bundle
    if (bundleData.type !== 'custom') {
      window.location.href = '/pages/configure-bundle-step-2';
    }
    // reset bundle if not editing, must come after redirect check
    if (startNew) {
      bundleData = customBundle.remove();
    }
    //
    build();
    addListeners();

    await indexDBService.init();
    if (startNew) {
      indexDBService.clear();
    }
  }

  const addListeners = () => {
    backBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        confirmModal.dataset.show = 'true';
      })
    });
    //
    confirmModal.addEventListener('modalevent', (e) => {
      if (e.detail.name === 'dismiss') {
        customBundle.remove();
        window.location.href = backBtns[0].href;
      } else if (e.detail.name === 'confirm') {
        confirmModal.dataset.show = 'false';
      }
    });
    //
    selectBtns.forEach((btn) => {
      btn.addEventListener('click', onSelect);
    });
    //
    productModal.addEventListener('modalevent', (e) => {
      if (e.detail.name === 'add') {
        bundleData = customBundle.addVariant(e.detail.variantId, 1, e.detail.price, e.detail.title, e.detail.image);
        curSelectBtn = selectBtns.find((btn) => (
          btn.dataset.productVariant === bundleData.variantId
        ));
        addContainer();
        productModal.dataset.show = 'false';
      }
      //
      if (e.detail.name === 'form data') {
        let containerVariantId;
        let containerVariantName;
        const customText = e.detail.custom_text;
        const customImage = e.detail.custom_image ? e.detail.custom_image.name : null;
        if (e.detail.custom_image) addFile(e.detail.custom_image);
        //
        if (e.detail.container_variant) {
          const arr = e.detail.container_variant.split('-');
          containerVariantId = arr[0];
          containerVariantName = arr[1].trim();
        }
        //
        bundleData = customBundle.addVariant(e.detail.variantId, 1, e.detail.price, e.detail.title, e.detail.image, containerVariantId, containerVariantName, customText, customImage);
        curSelectBtn = productModalLaunchBtns.find((btn) => (
          btn.tagName === 'BUTTON' && btn.dataset.productVariant === bundleData.variantId
        ));
        addContainer();
        productModal.dataset.show = 'false';
      }
    });
    //
    productModalLaunchBtns.forEach((el) => {
      el.addEventListener('click', openProductModal);
    });
    //
    intersectional.addEventListener('itemsloaded', (e) => {
      filters.dataset.loaded = e.detail.count;
    });
    //
    intersectional.addEventListener('itemsadded', (e) => {
      filters.dataset.count = e.detail.count;
      //
      items = document.querySelectorAll('.configurator-grid__items__grid-item');
      //
      selectBtns.forEach((btn) => {
        btn.removeEventListener('click', onSelect);
      });
      //
      selectBtns = Array.from(document.querySelectorAll('[data-select-product-btn]'));
      //
      selectBtns.forEach((btn) => {
        btn.addEventListener('click', onSelect);
      });
      //
      productModalLaunchBtns.forEach((el) => {
        el.removeEventListener('click', openProductModal);
      });
      //
      productModalLaunchBtns = Array.from(document.querySelectorAll('[data-launch-modal]'));
      //
      productModalLaunchBtns.forEach((el) => {
        el.addEventListener('click', openProductModal);
      });
      //
      const btn = selectBtns.find((el) => el.dataset.productVariant === customBundle.data.variantId);
      if(btn) btn.dataset.selected = 'true';
    });
  }

  const addFile = async (file) => {
    const request = indexDBService.addFile(file);
    if (request.error) {
      throw new Error('There was a problem saving the the uploaded image.');
    }
  }

  const build = () => {
    if (customBundle.hasContainer) {
      curSelectBtn = selectBtns.find((btn) => btn.dataset.productVariant === bundleData.variantId);
      if (!curSelectBtn) curSelectBtn = productModalLaunchBtns.find((btn) => (
        btn.tagName === 'BUTTON' && btn.dataset.productVariant === bundleData.variantId
      ));
      addContainer();
    }
    //
    if (customBundle.hasGifts) {
      bundleData.addedComponentReference.forEach((r, i) => {
        addGift(i);
      });
    }
    // if card exists in data: add to sideCart
    if (customBundle.hasCard) {
      addCard();
    }
    //
    sideCart.show();
  }

  const openProductModal = (e) => {
    const variantId = e.currentTarget.dataset.productVariant;
    productModal.dataset.productVariantId = variantId;
    productModal.dataset.show = 'true';
  }

  const onSelect = (e) => {
    Logger.info(`${NAME} > onSelect, ${e.target.dataset.productTitle} ${e.target.dataset.productVariant} ${e.target.dataset.productPrice}`);
    curSelectBtn = e.target;
    const image = document.querySelector(`#img-${e.target.dataset.productVariant}`)?.src
    bundleData = customBundle.addVariant(e.target.dataset.productVariant, 1, e.target.dataset.productPrice, e.target.dataset.productTitle, image);
    addContainer();
  }

  const addContainer = () => {
    const data = {
      variantId: bundleData.variantId,
      price: bundleData.price * bundleData.quantity,
      quantity: bundleData.quantity,
      title: bundleData.title,
      icon: 'trash',
      image: bundleData.image,
      extraContent1: bundleData.containerVariantName ? `option: ${bundleData.containerVariantName}` : null,
      extraContent2: bundleData.customText ? `text: ${bundleData.customText}` : null,
      extraContent3: bundleData.customImage ? `image: ${bundleData.customImage}` : null,
      btnCallBack: removeContainerCB
    }
    //
    if (sideCart.hasContainer) {
      sideCart.updateContainer(data);
    } else {
      sideCart.addItem('container', data);
    }
    sideCart.total = customBundle.getTotal();
    sideCart.count = customBundle.getNumItems();
    selectBtns.forEach((btn) => {
      btn.dataset.selected = 'false';
    });
    //
    resetBtns();
    if (!!curSelectBtn) {
      curSelectBtn.dataset.selected = 'true';
      if (curSelectBtn.parentElement.dataset.quantity) curSelectBtn.parentElement.dataset.quantity = data.quantity;
      if (curSelectBtn.parentElement.parentElement.dataset.quantity) curSelectBtn.parentElement.parentElement.dataset.quantity = data.quantity;
    }
  }

  const resetBtns = () => {
    [...selectBtns, ...productModalLaunchBtns].forEach((btn) => {
      btn.dataset.selected = 'false';
    });
    items.forEach(el => el.dataset.quantity = '0');
  }

  const removeContainer = () => {
    bundleData = customBundle.remove();
    sideCart.removeContainer();
    sideCart.total = customBundle.getTotal();
    sideCart.count = customBundle.getNumItems();
    curSelectBtn.dataset.selected = 'false';
    curSelectBtn.nextElementSibling.dataset.value = 1;
    curSelectBtn.parentElement.parentElement.dataset.quantity = 0;
  }

  const removeContainerCB = (e) => {
    if (e.target.dataset.icon === 'trash') {
      removeContainer();
    }
  }

  const addGift = (index) => {
    const data = {
      variantId: bundleData.addedComponentReference[index],
      price: bundleData.addedComponentPrices[index] * bundleData.addedComponentQuantities[index],
      quantity: bundleData.addedComponentQuantities[index],
      title: bundleData.addedComponentTitles[index],
      icon: 'trash',
      image: bundleData.addedComponentImages[index],
      btnCallBack: removeGiftCB
    }
    //
    sideCart.addItem('gifts', data);
    sideCart.total = customBundle.getTotal();
    sideCart.count = customBundle.getNumItems();
  }

  const removeGiftCB = (e) => {
    if (e.target.dataset.icon === 'trash') {
      bundleData = customBundle.updateGift(e.target.dataset.variantId, { quantity: 0 });
      sideCart.removeGift(e.target.dataset.variantId);
      sideCart.total = customBundle.getTotal();
      sideCart.count = customBundle.getNumItems();
    }
  }

  const addCard = () => {
    const data = {
      variantId: bundleData.card.variantId,
      price: bundleData.card.price * bundleData.card.quantity,
      quantity: 1,
      title: bundleData.card.title,
      icon: 'trash',
      image: bundleData.card.image,
      extraContent1: bundleData.card.message ? `message: ${bundleData.card.message}` : null,
      extraContent2: bundleData.card.signature ? `signature: ${bundleData.card.signature}` : null,
      btnCallBack: removeCardCB
    }
    //
    if (sideCart.hasCard) {
      sideCart.updateCard(data);
    } else {
      sideCart.addItem('card', data);
    }
    sideCart.total = customBundle.getTotal();
    sideCart.count = customBundle.getNumItems();
  }

  const removeCardCB = (e) => {
    if (e.target.dataset.icon === 'trash') {
      bundleData = customBundle.updateCard({ quantity: 0 });
      sideCart.removeCard();
      sideCart.total = customBundle.getTotal();
      sideCart.count = customBundle.getNumItems();
    }
  }
  
  init();

}